import { apiClient } from '@app/api';
import { useMemo } from 'react';

export function useStationLiveHlsUrl(stationId: string) {
  const src = useMemo(() => {
    if (!stationId) {
      return;
    }

    return apiClient.generateUrl(`/segments/stations/${stationId}/hls-live?windowSeconds=${120}`, {
      secure: true,
    });
  }, [stationId]);

  return src;
}
